import React, { useState } from "react";
import { formatUrl } from "../../helpers/functions";

function ItemCarousel({ prod }) {
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(false);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const styleProp = {
    backgroundImage: !isHover
      ? `url(${prod?.imageCarousel[0]?.url})`
      : `url(${prod?.imageCarouselHover[0]?.url})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "90%",
    backgroundPosition: "center bottom",
    zIndex: 1,
    display: "flex",
    alignContent: "flex-end",
    margin: "auto",
    marginRight: '.5rem',
    marginLeft: '.5rem',
  };
  return (
    <>
      <article className="item mb-4">
        <a
          id="carousel_items"
          style={styleProp}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="carousel__niniosImg mb-2 mb-sm-0"
          href={`/producto/${formatUrl(prod?.title)}`}
        >
          <p className="mx-auto subtitle_prod_carrousel">{prod?.title}</p>
        </a>
      </article>
    </>
  );
}

export default ItemCarousel;
